import script from "./BroadcastComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./BroadcastComposeModal.vue?vue&type=style&index=0&id=17c51278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c51278"]])

export default __exports__